import InlineButton from './InlineButton';

export default InlineButton;
